(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = true;
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      this.isHome = this.dataset.home === 'true';

      if (this.isHome) {
        window.addEventListener('scroll', this.onScroll.bind(this), false);
        document.documentElement.style.setProperty('--header-height', `-${this.header.offsetHeight}px`);
      } else {
        this.header.classList.add('scrolled-past-header');
        document.documentElement.style.setProperty('--header-height', `0px`);
      }

      this.header.classList.add('shopify-section-header-sticky');

      this.currentScrollTop = 0;
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `-${this.header.offsetHeight}px`);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > 320) {
        this.header.classList.add('scrolled-past-header');
      } else {
        this.header.classList.remove('scrolled-past-header');
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.querySelectorAll('.header__inline-menu header-menu').forEach((menu) => {
      const details = menu.querySelector('details');
      const summary = details.querySelector('summary');
      let openTimer;
      let closeTimer;

      const setOpen = (open) => {
        details.open = open;
        summary.setAttribute('aria-expanded', open);
      };

      // 100ms hover intent so sweeping across the bar doesn't flicker menus open
      menu.addEventListener('mouseenter', () => {
        clearTimeout(closeTimer);
        openTimer = setTimeout(() => {
          document.querySelectorAll('.header__inline-menu details[open]').forEach((other) => {
            if (other !== details) {
              other.open = false;
              other.querySelector('summary').setAttribute('aria-expanded', false);
            }
          });
          setOpen(true);
        }, 100);
      });

      menu.addEventListener('mouseleave', () => {
        clearTimeout(openTimer);
        closeTimer = setTimeout(() => setOpen(false), 150);
      });

      summary.addEventListener('click', (event) => {
        const url = summary.dataset.url;
        // event.detail is 0 for keyboard-generated clicks — those keep the toggle
        if (!url || url === '#' || event.detail === 0) return;
        event.preventDefault();
        if (event.metaKey || event.ctrlKey || event.shiftKey) {
          window.open(url, '_blank');
        } else {
          window.location.href = url;
        }
      });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
